import { Link } from 'react-router-dom'
import { useTranslation } from '../../core/hooks/useTranslation'
import LanguageToggle from '../ui/LanguageToggle'

interface HeaderProps {
  showRegisterButton?: boolean
  showSignInButton?: boolean
  className?: string
  headerIsSticky?: boolean
}

export default function Header({ 
  showRegisterButton = false, 
  showSignInButton = false,
  className = '',
  headerIsSticky = true
}: HeaderProps) {
  const { t } = useTranslation()

  return (
    <nav className={`border-b border-gray-100 bg-white/95 backdrop-blur-sm ${headerIsSticky ? 'sticky top-0 z-50' : ''} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse group">
            <img
              src="/assets/images/logo.png"
              alt="Hatli Logo"
              className="h-8 w-auto transition-transform group-hover:scale-105"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#1E293B]">{t('siteName')}</span>
              <p className="text-xs text-gray-500 leading-tight">
                {t('siteDescription')}
              </p>
            </div>
          </Link>
          
          <div className="flex items-center gap-3">
            <LanguageToggle />
            
            {showSignInButton && (
              <Link
                to="/login"
                className="text-sm text-gray-600 hover:text-gray-900 font-medium transition-colors px-3 py-2"
              >
                {t('homepageSignIn')}
              </Link>
            )}
            
            {showRegisterButton && (
              <Link
                to="/register"
                className="px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-700 rounded-lg hover:from-primary-700 hover:to-primary-800 shadow-md hover:shadow-lg transition-all"
              >
                {t('homepageStartFree')}
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

